import {
  ActionType,
  IConsultationDetailsResponse,
  ConsultationDetailsPayload,
} from "models/consultations/consultationDetails";

export const getConsultationDetailsAction = (
  payload: ConsultationDetailsPayload
) => {
  return {
    type: ActionType.GET_CONSULTATION_DETAILS,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.GET_CONSULTATION_DETAILS_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IConsultationDetailsResponse) => {
  return {
    type: ActionType.GET_CONSULTATION_DETAILS_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.GET_CONSULTATION_DETAILS_RESET,
  };
};
